
<div class="col-xs-12 p-0">
  <div class="col-xs-12 cartTitle" *ngIf="!hideTitle"><em class="fas fa-cart-plus pr-3"></em><span>Cart</span><a class="fa fa-pencil-square-o mx-3" [routerLink]="['/cart', 'edit']" [queryParams]="{ username: user.get('username') }" target="_blank"></a>
    <div class="cartRow"><a class="text-info" href="/cart/{{cart.objectId}}" target="_blank"></a>
      <ng-container *ngFor="let product of cart.lineItems;"><a class="dib mr-2 mt-2 product-label bg-black clr-white">{{ product.title }} [{{product.quantity}}]</a></ng-container>
    </div>
  </div>
</div>